import './ui.css';

/**
 * Eyebrow + heading + lead. The heading level is explicit so pages can keep
 * a correct document outline (WCAG 1.3.1) instead of choosing a tag for looks.
 */
const SectionHeader = ({
  eyebrow,
  title,
  lead,
  id,
  level = 2,
  align = 'start',
  className = '',
}) => {
  const Heading = `h${level}`;

  return (
    <div
      className={`section__header${align === 'center' ? ' section__header--center' : ''} ${className}`.trim()}
    >
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <Heading id={id} className="section__title">
        {title}
      </Heading>
      {lead && <p className="section__lead">{lead}</p>}
    </div>
  );
};

export default SectionHeader;
